<script>
  /**
   * Guide how to quickly update the Terms and Conditions text:
   *
   * @param 1 - Access this website: https://mconverter.eu/convert/docx/html/ and insert your new Terms & Conditions.docx
   * @param 2 - Copy entire body from generated HTML file and insert it instead of the root div element in the template section. (Don't forget to replace <body> tag with <div>)
   * @param 3 - Change links to some redirects manually. Most probably they're not set in the document.
   *
   * P.S. You might need to delete a couple of <p> tags from the end if document doesn't end with a new line.
   * Just to avoid blank spacing
   */
  export default {
    name: 'TermsAndConditionsText',

    props: {
      dark: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<template>
  <div class="tnc-wrapper">
    <div :class="{ dark }">
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="6" style="font-size: 22pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        Terms &amp; Conditions
                        <br />
                        <br />
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        These Terms and Conditions form a binding legal agreement between users and the site operator
                        and apply to your use of any of our Games and our Platform in any way through any electronic
                        device (web, mobile, tablet, or any other device).&nbsp;
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>Welcome to MaxQuest.</b></font>
        </font>
        <font color="#000000"><font face="Barlow, serif">By creating an account with MaxQuest</font></font>
        <a href="http://www.maxquest.com/">
          <font color="#1155cc">
            <font face="Barlow, serif"><u>(https//.www.maxquest.com)</u></font>
          </font>
        </a>
        <font color="#000000">
          <font face="Barlow, serif">
            or otherwise accessing and using the platform (as further defined below), you agree to comply with the Terms
            and Conditions of MQ Technology DWC-LLC, the Privacy Policy,&nbsp; Responsible Gaming Policy
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>,</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            Customer Acceptance Policy and other game-specific or promotion-specific terms relevant to your
            Participation, and all applicable platform or game rules that may be published, which form a legal agreement
            between you and MQ Technology DWC-LLC.&nbsp;
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif">
            You must read these Terms and Conditions carefully before checking the box to indicate acceptance. If you do
            not agree or comply with any provision of these Terms and Conditions or any other linked policy, rules, or
            terms, you may not use the platform or play any game.
          </font>
        </font>
      </p>
      <p
        align="left"
        style="
          line-height: 115%;
          page-break-inside: auto;
          orphans: 2;
          widows: 2;
          margin-bottom: 0.11in;
          border: none;
          padding: 0in;
          background: transparent;
          page-break-before: auto;
          page-break-after: auto;
        "
      >
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        PLEASE NOTE THAT THESE TERMS AND CONDITIONS INCLUDE A PROVISION WAIVING THE RIGHT TO PURSUE ANY
                        CLASS,&nbsp; GROUP, OR REPRESENTATIVE CLAIM AND REQUIRING YOU TO PURSUE PAST, PENDING, AND
                        FUTURE DISPUTES&nbsp; BETWEEN YOU AND MQ TECHNOLOGY DWC-LLC THROUGH INDIVIDUAL ARBITRATION
                        UNLESS YOU OPT-OUT WITHIN THE SPECIFIED TIME FRAME.&nbsp; SEE CLAUSE
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <font face="Barlow, serif">20</font>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        FOR MORE INFORMATION
                        <br />
                        <br />
                        <br />
                        1. DEFINITIONS
                        <br />
                        <br />
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <b><span style="background: transparent">1.10 Player Account:</span></b>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">An account held by a registered player.</span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>1.11 Player or 'you':</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            Refers to any person who participates, whether or not they are a Registered Customer.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>1.12 Registered Customer:</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            A Player who has successfully registered a Player Account, whether that account is considered active or not.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>1.13 Terms and Conditions:</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">Refers to these terms and conditions, as amended as and when required.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>1.14 Third-Party Website:</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">A third-party website not controlled by MQ Technology DWC-LLC.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>1.15 Restricted State/Country:</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            Any state or country within which the operation of MaxQuest promotional play is restricted.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>1.16 Inactive Account:</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            A Player Account that has not recorded any log-in or log-out activity for a continuous period exceeding
            twelve (12) months.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>1.17 Excluded Territory:</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            Any territory in which gameplay is not permitted.&nbsp;
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif">
          <font size="3" style="font-size: 13pt"><b>2. FUND PROTECTION</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.17in; margin-bottom: 0.17in">
        <font face="Barlow, serif">
          2.1 MQ Technology DWC-LLC ensures the security of funds by holding an amount equivalent to the total value of
          cryptocurrency in Registered Players' accounts within Cold Wallets. These wallets are entirely separate from
          hot wallet business accounts to provide maximum protection.
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.17in; margin-bottom: 0.17in">
        <font face="Barlow, serif">
          Our infrastructure is continuously monitored by security experts specializing in cryptocurrency, website
          management, and internal security. To safeguard your account against unauthorized access, it is essential to:
        </font>
      </p>
      <ul>
        <!--        <li>-->
        <!--          <p style="line-height: 100%; margin-top: 0.17in; margin-bottom: 0in">-->
        <!--            <font face="Barlow, serif">Complete full KYC verification.</font>-->
        <!--          </p>-->
        <!--        </li>-->
        <li>
          <p style="line-height: 100%; margin-bottom: 0in">
            <font face="Barlow, serif">Enable Two-Factor Authentication (2FA).</font>
          </p>
        </li>
        <li>
          <p style="line-height: 100%; margin-bottom: 0.17in">
            <font face="Barlow, serif">
              Implement robust internal security measures to defend against phishing attacks and malware (e.g.,
              trojans).
            </font>
          </p>
        </li>
      </ul>
      <p style="line-height: 100%; margin-top: 0.17in; margin-bottom: 0.17in">
        <font face="Barlow, serif">
          Please note that we cannot be held responsible for any losses incurred due to insufficient security measures
          on your part.
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#000000">
          <font face="Barlow, serif"><font size="5" style="font-size: 20pt">3. PLAYER PARTICIPATION</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.1 You declare and warrant that:</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.2&nbsp;</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You confirm that you are at least 18 years of age or have reached the legal age of majority as required by
            the laws of your jurisdiction of residence. Additionally, you affirm that you are legally permitted to
            participate in the Games offered on the Platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You do not engage in the MaxQuest games if you reside in a restricted State or Country.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You participate in the Games strictly for recreational and entertainment purposes in your personal capacity
            only.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You participate in the Games on your behalf and not on behalf of any other person.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.6</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            All information you provide to us under these Terms and Conditions must be true, complete, and accurate. You
            agree to promptly notify us of any changes to this information to ensure it remains current and correct.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.7</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The money you use to deposit is not tainted with any illegality, and it does not originate from any illegal
            activity or source or from ill-gotten means.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.gjdgxs"></a>
        <font color="#434343">
          <font face="Barlow, serif"><b>3.8</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You will not deposit money from a business or corporate account but only from an account held in your name.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.9</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You agree not to engage in any fraudulent, collusive, or unlawful activities, including but not limited to
            game-fixing, in connection with your or any third parties' participation in any Games. You will not use any
            software-assisted tools, such as automated bots, or hardware devices to participate in the Games. We reserve
            the right to invalidate any participation in the event of such behavior and actively monitor for such
            activity.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.10</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must use a valid payment method that is lawfully registered in your name for making deposits.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.11</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You will not sell or trade for value, seek to sell or trade for value, or accept as a sale or trade for
            value any Merchandise provided to you by MaxQuest.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.12</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Withdrawal requests from restricted states or countries will be voided, and the value will be returned to
            the account.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.13</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Should it become apparent that you are a permanent resident of a Restricted State or Country, your balance
            will be retained, and your account will be shut down.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; page-break-inside: auto; margin-bottom: 0.11in">
        <font face="Barlow, serif"><b>3.14</b></font>
        <font face="Barlow, serif"></font>
        <font face="Barlow Light, serif">
          Purchases made from within an Excluded Territory will be voided and refunded, minus an administration fee of
          10%, in addition to any fees that may be levied by the bank or financial institution managing the reversal.
          Excluded territories include, but are not limited to, Afghanistan, Albania, Belarus, Botswana, Brazil, Burma
          (Myanmar), Burundi, Cambodia, China, Cuba, Democratic Republic of Congo, Ethiopia, Germany, Ghana,
          Guinea-Bissau, Haiti, India, Iran, Iraq, Italy, Jamaica, Lebanon, Libya, Mali, Mauritius, Mongolia, Myanmar,
          Nicaragua, North Korea, Pakistan, Republic of the Congo, Somalia, South Sudan, Sri Lanka, Sudan, Syria,
          Trinidad and Tobago, Tunisia, Uganda, Venezuela, Vietnam, Yemen, Zimbabwe, as well as the following excluded
          U.S. States: Arizona, Arkansas, Connecticut, Delaware, Iowa, Louisiana, Montana, South Carolina, South Dakota,
          and Tennessee.
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.15</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            It is the sole responsibility of a Player to ensure that their Participation is lawful in their
            jurisdiction. Any person who knowingly breaches clause 3, including any attempt to circumvent this
            restriction, for example, by using a VPN, proxy, or similar service that masks or manipulates the
            identification of your real location or by providing false or misleading information regarding your location
            or place of residence, or by Participating from an Excluded Territory or through a third party or on behalf
            of a third party located in an Excluded Territory, is in breach of these Terms and Conditions. Such actions
            may constitute fraud and may result in criminal prosecution.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>3.16</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            By accepting these Terms and Conditions, you agree that your participation is solely at your own discretion,
            option, and risk. You waive any claims against MQ Technology DWC-LLC, its partners, and their respective
            directors, officers, or employees regarding any negative results or losses incurred from your gameplay.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <br />
        <br />
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <br />
        <br />
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000"><font face="Barlow, serif">4. LICENSE</font></font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>4.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            &nbsp;Subject to your agreement and continuing compliance with these Terms and Conditions, MQ Technology
            DWC-LLC grants you a personal, non-exclusive, non-transferable, non-sublicensable, revocable, limited
            license to access and use the Platform, through a supported web browser or mobile device. This license is
            solely for your personal, private entertainment and for no other purpose.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>4.2</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            These Terms and Conditions do not grant you any right, title, or interest in the Platform or its Content.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>4.3</b></font>
        </font>
        <font color="#000000"><font face="Barlow, serif"></font></font>
        <font face="Barlow, serif">
          By agreeing to these Terms and Conditions, you acknowledge that they define and restrict your license to use
          the Platform. If you fail to comply with or breach any of these Terms, your license to access and use the
          Platform, including its Games and Content, may be revoked immediately.
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>4.4</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            If the Platform or any Game is considered illegal under the laws of the jurisdiction in which you reside or
            are situated, you will not be granted any license to access or use the Platform or the relevant Game.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>5. YOUR ACCOUNT</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000"><font face="Barlow, serif">5.1&nbsp; Single Account</font></font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.1.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            You are permitted to have only one Player Account, including any Inactive Account, on the Platform. If you
            attempt to open more than one Player Account, all accounts you have opened or attempt to open may be closed,
            and any winnings made with such accounts may be withheld.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.1.2</b></font>
        </font>
        <font face="Barlow, serif">
          You must promptly notify us if you discover that you have more than one registered Player Account, whether
          active or not, on the same Platform. If you wish to change your surname and address, please contact our
          Customer Support via our contact page.
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.1.3&nbsp;</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            YOU’LL NEVER WIN WITH CREATING MULTIPLE ACCOUNTS. ENJOY 1 ACCOUNT AND THE ENDLESS OPPORTUNITIES TO WIN VS
            BEING BANNED FOR LIFE FOR BONUS ABUSE.
            <br />
            <br />
            5.2 Accuracy
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>5.2.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            You are required to keep your registration details up to date at all times. If you change your address,
            email, phone number, or any other contact details or personal information, contact Customer Support.&nbsp;
            The name that you provide to us in your Player profile must be identical to that listed on your government
            issued identification.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif">5.3 Security and Responsibility of Your Player Account</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.3.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            As part of the registration process, you will need to choose a password to log into the Platform. It is your
            sole and exclusive responsibility to ensure that your Player Account login details and any Payment Mediums
            are kept secure and accessible only by you. You accept full responsibility for any unauthorized use of your
            Player Account and any activity associated with your Player Account, including by a minor (which is
            prohibited in all cases).
          </font>
        </font>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <b>
                      <span style="background: transparent">
                        <br />
                        <br />
                        5.3.2
                      </span>
                    </b>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        You must not share your Player Account or password with another person, allow anyone else to
                        access or use your Player Account, or engage in any activity that may compromise the security of
                        your Player Account.
                        <br />
                        <br />
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#434343">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <b><span style="background: transparent">5.3.3</span></b>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#434343">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        If you become aware of or reasonably suspect that the security of your Player Account has been
                        compromised, including instances of loss, theft, or unauthorized disclosure of your password and
                        Player Account details, you must notify us immediately.
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>5.3.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Your responsibility extends to any purchases or gameplay made under the Player Account, whether you
            authorized those purchases or not.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#434343">
          <font face="Barlow, serif"><b>5.3.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You acknowledge that your Player Account may be terminated if someone else uses it and engages in any
            activity that breaches these Terms and Conditions or is otherwise illegal.
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            <br />
            <br />
            5.4 Account Transfers
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.4.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            You are not allowed to transfer or sell your MaxQuest Account.
            <br />
            <br />
            5.5 Inactive Player Accounts
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.5.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            We reserve the right to deactivate your Player Account if it is deemed to be an Inactive Account. An
            inactive account that has not been accessed for over twelve (12) consecutive months.
            <br />
            <br />
            5.6 Closing of Player Accounts
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>5.6.1</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            If you wish to close your Player Account, you may do so by contacting Customer Support. Closing your Player
            Account will result in the loss of all access to and rights to use or enjoy the games offered on the
            MaxQuest site.
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            <b>
              <br />
              <br />
            </b>
          </font>
        </font>
        <font face="Barlow, serif"><b>5.6.2</b></font>
        <font face="Barlow, serif">
          You are free to return to MaxQuest and open a new account at any time. However, please note that this will
          typically be a completely new account, and you will not be able to redeem any balance from your previous
          account or activate any Welcome Bonus. Exceptions to this policy will be considered on a case-by-case basis.
          We reserve the right, at our sole discretion, to impose limits, suspend, close, or refuse to open any Player
          Account.
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            <br />
            <br />
            6. GAMEPLAY TRANSACTIONS
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif">
            6.1 Rules&nbsp;
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><b>6.1.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Games offered on the Platform may have their own rules, which are available on the Platform. It is your
            responsibility to read the rules of a Game before playing. You must familiarize yourself with the applicable
            terms of play and read the relevant rules before playing any Game.
            <br />
            <br />
            6.2 Deposits
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><br /></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            <b>
              <br />
              6.2.1
            </b>
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">You must legally and beneficially own the Payment Medium you use to deposit.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif"><b>6.2.2</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            We reserve the right to decline payments that are suspected to be compromised or flagged.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>6.2.3</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            You agree that we and our Payment Administration Agents and payment facilitators may store your payment
            information. By accepting these Terms and Conditions, you authorize MQ Technology DWC-LLC and our Payment
            Administration Agents and Payment Facilitators to store your payment credentials in compliance with
            applicable payment processing regulations.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>6.2.4</b></font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC initiates the processing of crypto payments as soon as you click "Send Funds" from
            your wallet. Our automated systems track the transaction on the blockchain, and once the funds are detected
          </font>
        </font>
        <font face="Barlow, serif">they</font>
        <font color="#000000">
          <font face="Barlow, serif">
            will be credited to your MaxQuest Balance.
            <br />
            <br />
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif"><b>6.2.5</b></font>
        </font>
        <font color="#000000"><font face="Barlow, serif"></font></font>
        <font face="Barlow, serif">
          You agree to promptly notify us of any billing issues or discrepancies. As cryptocurrency transactions are
          irreversible and require immediate attention, failing to report such issues in a timely manner will forfeit
          your right to dispute them. You also acknowledge that resolution may not always be feasible and agree not to
          hold us liable for any losses resulting from customer errors.
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#000000">
          <font face="Barlow, serif">
            <br />
            6.3 Crypto Transactions
          </font>
        </font>
      </p>
      <p
        align="left"
        style="
          line-height: 115%;
          page-break-inside: auto;
          orphans: 2;
          widows: 2;
          margin-top: 0.21in;
          margin-bottom: 0.25in;
          border: none;
          padding: 0in;
          background: transparent;
          page-break-before: auto;
          page-break-after: auto;
        "
      >
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <b><span style="background: transparent">6.3.1</span></b>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <font face="Barlow, serif">
          MaxQuest supports Virtual Currencies; however, we are not responsible for the underlying Blockchain associated
          with these currencies. We have no control over the operations of any Blockchain. Our role is solely limited to
          accepting cryptocurrency payments and redeeming winnings to players' designated wallets. MaxQuest does not
          claim ownership or regulation over any part of the fundamental application that governs the Virtual Currencies
          we support.
        </font>
        <span style="font-variant: normal">
          <font color="#000000">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <span style="font-weight: normal">
                      <span style="background: transparent">
                        <br />
                        <br />
                      </span>
                    </span>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <span style="font-variant: normal">
          <font color="#434343">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <b><span style="background: transparent">6.3.2</span></b>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
        <font color="#434343">
          <font face="Barlow, serif">
            Fees may apply to transactions sent to or from your wallet. MaxQuest reserves the right to charge, share, or
            cover any gas fees or transaction costs with the customer at our discretion. All applicable fees will be
            clearly outlined prior to any transaction and can be reviewed in our Cashier. If you have any questions
            regarding transaction costs, please refer to our FAQ section.
          </font>
        </font>
        <span style="font-variant: normal">
          <font color="#434343">
            <span style="text-decoration: none">
              <font face="Barlow, serif">
                <font size="3" style="font-size: 12pt">
                  <span style="font-style: normal">
                    <b><span style="background: transparent"></span></b>
                  </span>
                </font>
              </font>
            </span>
          </font>
        </span>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>6.3.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            By accepting these Terms of Use, you accept and acknowledge that MaxQuest may make use of select third-party
            payment processors to facilitate transactions between you and MaxQuest.
          </font>
        </font>
      </p>
      <!--      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">-->
      <!--        <font color="#434343">-->
      <!--          <font face="Barlow, serif"><b>6.3.5</b></font>-->
      <!--        </font>-->
      <!--        <font color="#434343">-->
      <!--          <font face="Barlow, serif">-->
      <!--            MaxQuest reserves the right to conduct KYC verification procedures for any account usage, game play,-->
      <!--            redemption, purchase, suspected instances of terms violations, or security flags.-->
      <!--          </font>-->
      <!--        </font>-->
      <!--      </p>-->
      <!--      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">-->
      <!--        <font color="#434343">-->
      <!--          <font face="Barlow, serif"><b>6.3.6</b></font>-->
      <!--        </font>-->
      <!--        <font color="#434343">-->
      <!--          <font face="Barlow, serif">-->
      <!--            Additionally, each account will be independently suspended until the necessary KYC checks are completed once-->
      <!--            it reaches a redemption threshold. This threshold is determined based on the account's risk profile over its-->
      <!--            lifetime, and these measures are in place to prevent account takeovers and other forms of abuse.-->
      <!--          </font>-->
      <!--        </font>-->
      <!--      </p>-->
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343"><font face="Barlow, serif">6.4.1</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <b>6.4.7</b>
        By agreeing to these Terms of Use, you accept and acknowledge that MaxQuest assumes no responsibility or
        liability for the function of the main software and makes no promises regarding its availability or safety.
        <br />
        <br />
        <font size="3" style="font-size: 12pt">
          6.5 Void Games
          <br />
          <br />
        </font>
        <font size="3" style="font-size: 12pt"><b>6.5.1</b></font>
        <font size="3" style="font-size: 12pt">
          We reserve the right to declare Participation in a Game void, partially or in full, if, in our sole
          discretion, we deem it evident that there was an error, mistake, misprint, or technical error on the
          pay-table, win-table, minimum or maximum stakes, leaderboards, or software. At our sole discretion, we may
          offer a bug bounty for any such errors.
        </font>
        <br />
        <br />
        <font face="Barlow, serif">6.6 Network Errors</font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#434343">
          <font face="Barlow, serif"><b>6.6.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We do not assume responsibility for network errors beyond our server infrastructure. Players must ensure a
            strong and stable connection, with a wired connection being preferred. We recommend checking latency within
            games before participating in any matches. Suppose a lost connection or network error occurs. In that case,
            our Customer Service will examine the player’s latency during the game and the source of the disconnection
            to decide on the appropriate action. Once a player enters a game and loses funds to another player, those
            funds are typically non-recoverable.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#434343">
          <font face="Barlow, serif"><br /></font>
        </font>
        <font color="#000000"><font face="Barlow, serif">6.7 Final Decision</font></font>
      </p>
      <h1 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#000000">
          <font face="Barlow, serif">
            <font size="3" style="font-size: 12pt"><b>6.7.1</b></font>
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            <font size="3" style="font-size: 12pt">
              In the event of a discrepancy between the result showing on a user’s device and the MQ Technology DWC-LLC
              server software, the result showing on the MQ Technology DWC-LLC server software will be the official and
              governing result.
            </font>
          </font>
        </font>
        <font color="#000000">
          <font face="Barlow, serif">
            <br />
            <br />
            7. PROMOTIONS &amp; TOURNAMENTS
          </font>
        </font>
      </h1>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">7.1 General</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.1.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            All promotions, including Games played in Promotional Play, contests, special offers, tournaments, and
            prizes, are subject to these Terms and Conditions and to additional terms that may be published at the time
            of the promotion.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.1.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            &nbsp;In the event and to the extent of any conflict between these Terms and Conditions and any
            promotion-specific terms and conditions, these Terms and Conditions will prevail in the event
            promotion-specific terms are not in alignment.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.1.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC reserves the right to remove or modify such promotions without prior notice to you.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.1.4</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">Unless stated otherwise</font></font>
        <font color="#434343">
          <font face="Barlow, serif"><b>,</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">All promotions and rewards are based on EST (Eastern Standard Time).</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.1.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If MQ Technology DWC-LLC determines, at our sole discretion, that you are abusing any promotion to gain an
            unfair advantage for yourself or others, we reserve the right to withhold, deny, or cancel any promotion or
            bonus as we deem appropriate.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.1.6</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Players' collusion or deposit dumping is prohibited, and any accounts involved in such activities will be
            closed and the balance forfeited.
          </font>
        </font>
      </p>
      <h3 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif">
            <font size="3" style="font-size: 12pt"><b>7.1.7</b></font>
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            <font size="3" style="font-size: 12pt">
              You confirm that you grant MQ Technology DWC-LLC an irrevocable, perpetual, worldwide, non-exclusive,
              royalty-free license to use in whatever way we see fit, and without further acknowledgment of you as the
              author, any Content you post or publish as part of a promotion, contest, or competition.
            </font>
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            <br />
            <br />
            7.2 Refer Friends
          </font>
        </font>
      </h3>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.2.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            To participate in MaxQuest's Referral Program, you must opt in on the "Refer Friends" webpage on
            maxquest.com. Upon opting in, you'll receive a unique referral link. Share this link on social media or via
            email to invite friends to join
          </font>
        </font>
        <a href="http://maxquest.com/">
          <font color="#1155cc">
            <font face="Barlow, serif"><u>maxquest.com</u></font>
          </font>
        </a>
        <font color="#434343"><font face="Barlow, serif">.</font></font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.2.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Referral Link: Upon opting in, participants will receive a unique referral link. This link is intended to be
            shared with friends and acquaintances via social media or email to invite them to join maxquest.com.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">7.3 Commission Structure</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.3.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The commission structure applies solely to Player vs Player Games and is only applicable during the referred
            player’s first 30 days of membership.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.3.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            After 30 days of the referred player's membership, no further commissions will be earned.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.3.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Standard Commission: Participants are entitled to receive 10% of the rake incurred by referred players in
            Player vs Player Games within their first 30 days.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">7.4 Eligibility</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.4.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Only gameplay conducted with non bonus deposits is eligible for Refer Friends (RAF) commission.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">7.5 Calculation Methodologies</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.5.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Player vs Player Games:
            <br />
            House rake: Equivalent to 10% of each player's bid.
            <br />
            RAF Commission: 10% of the rake derived from referred players' bids made from non bonus deposits.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><b>7.5.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Commission Calculation Examples:
            <br />
            Multiplayer Game Example:
            <br />
            The referred player places a bid of $100.
            <br />
            House prize multiplier = 10% of $100 = $10.
            <br />
            RAF Commission = 10% of $5 = $.50.
            <br />
            <br />
            7.6 General Terms
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.6.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MaxQuest reserves the right to modify, suspend, or terminate the Refer Friends program, in whole or in part,
            at any time and for any reason without prior notice.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.6.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Abuse or manipulation of the Refer Friends program, including but not limited to fraudulent activities, may
            result in disqualification from participation and forfeiture of commissions.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.6.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Participation in the Refer Friends program does not guarantee the receipt of commissions, which are subject
            to compliance with these terms and conditions.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font color="#434343">
          <font face="Barlow, serif"><b>7.6.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Players may transfer their balance to their player account, and it will immediately be available for
            redemption.
            <br />
          </font>
        </font>
        <font face="Barlow, serif">
          <br />
          8. REDEEMING
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font face="Barlow, serif">8.1 Redemption Methods</font>
      </p>
      <p style="line-height: 100%; margin-bottom: 0.11in">
        <font face="Barlow, serif"><b>8.1.1</b></font>
        <font face="Barlow, serif">
          When you choose to redeem in cryptocurrency, the payment will be made to the wallet from which you made the
          deposit, in the same currency you originally deposited. If this is not technically possible, the payment will
          be made to an alternative wallet, provided you are the legal and beneficial owner of that account. We reserve
          the right to require the use of the same payment method for redeeming as was used for the deposit.
          <!--          Additional KYC measures may be required to prevent account takeovers.-->
          <br />
          <br />
          8.2 Redemption Limits
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font face="Barlow, serif">We reserve the right to charge fees for processing redemptions.</font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font face="Barlow, serif"><b>8.2.1</b></font>
        <font face="Barlow, serif">The minimum redemption amount in a single transaction is $50 USD.</font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <!--        <font face="Barlow, serif"><b>8.2.2</b></font>-->
        <!--        <font face="Barlow, serif">Without KYC verification, you can redeem up to a maximum of $150 USD.</font>-->
        <font color="#ff0000">
          <font face="Barlow, serif">
            <br />
            <br />
          </font>
        </font>
        <font color="#434343"><font face="Barlow, serif">8.3 Accuracy of Details for Redemptions</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.3.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            It is your sole responsibility to ensure that the email address and crypto wallet details provided are
            accurate. If the details you have provided are not accurate, and we have processed the redemption using the
            details you have provided, the redemption of that Prize is complete, and we are not required to reissue the
            Prize.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.3.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We will not process payments into any account or online wallet that does not match your verified name or the
            name provided during registration, or that is not legally and beneficially owned by you.
            <!--            We reserve the right to require any level of KYC that our compliance team deems necessary to ensure the security of your account.-->
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <!--        <font color="#434343">-->
        <!--          <font face="Barlow, serif"><b>8.3.3</b></font>-->
        <!--        </font>-->
        <!--        <font color="#434343">-->
        <!--          <font face="Barlow, serif">-->
        <!--            KYC Documentation may be required for any redemptions unless otherwise stated.-->
        <!--          </font>-->
        <!--        </font>-->
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.3.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Redemption requests are reviewed upon submission.
            <!--            Completing KYC and verification promptly will help expedite the payment process. -->
            Please allow 24-48 business hours for review of gameplay and fraud prevention to ensure the validity and
            security of your request. Reviews and account holds may take longer if further investigation is required, or
            in the case of credit card or bank deposits, to verify the validity of the deposited funds. At our
            discretion, we may refund the original transaction to the card or bank, either in part or full, to count
            toward the redemption.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">8.4 Currency</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.4.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Players are responsible for ensuring that the correct and exact amount of USD and/or cryptocurrency is used
            when purchasing and redeeming.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.4.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Any crypto exchange transaction fees, charges, or related costs that you may incur as a result of, or in
            relation to, payments made by MQ Technology DWC-LLC to you are solely your responsibility. This includes any
            losses or additional costs arising from exchange fluctuations within the payment window.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">8.5 Timing and Frequency</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.5.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We process redemption requests in the order they are received, aiming to do so as soon as practicable.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.5.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">Delays in payments may occur due to our standard verification process.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.5.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Redemptions exceeding US Dollars ($2,000) may take additional time for security and fraud checks and may be
            disbursed in multiple installments to ensure accurate payment receipt and confirmation with the player.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.5.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Before processing any redemption, we may request legal identification, such as certified copies of passports
            or ID cards. Additionally, phone or facial verification may be conducted to confirm the user's identity.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            <font size="4" style="font-size: 14pt">8.6 Payment Administration Agents</font>
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.6.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You acknowledge that, at our discretion, we may appoint Payment Administration Agents to handle payments to
            or from Players on our behalf.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.6.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Payment Administration Agents have the same rights and privileges as we do under these Terms and Conditions.
            They can exercise these rights on our behalf or in their own name. We are not liable for any loss, damage,
            or liability resulting from the negligence or actions beyond the authority of Payment Administration Agents.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">8.7 Updating Payment Details</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.7.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You can update or add additional payment details only when logged into your Player Account during the
            redemption process, solely for the purpose of redeeming. We cannot update or add payment details on your
            behalf.
            <br />
            <br />
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif"><font size="4" style="font-size: 14pt">8.8 Mistaken Credits</font></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>8.8.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If your Player Account is mistakenly credited with a bonus due to technical or human error, the credited
            amount remains the property of MQ Technology DWC-LLC and will be deducted from your account. Should you
            redeem these funds before we identify the error, the amount redeemed will constitute a debt owed by you to
            us. You are required to promptly inform Customer Support of any such incorrect crediting.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">9. VERIFICATION</font></font>
      </p>
      <h3 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.b18nb9b8yjgf"></a>
        <font color="#434343"><font face="Barlow, serif">9.1 Legal obligation</font></font>
      </h3>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif">
            MaxQuest complies with legal and regulatory requirements regarding customer verification. We cannot accept
            users under the age of 18, 19, or 21, depending on the user’s jurisdictional requirements, and we are
            committed to preventing verification fraud.
          </font>
        </font>
      </p>
      <h3 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.sed29ceffsic"></a>
        <font color="#434343"><font face="Barlow, serif">9.2 Process</font></font>
      </h3>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif">
            All MaxQuest players can go to their Profile settings
            <!--            or-->
          </font>
        </font>
        <!--        <a href="https://chat.openai.com/c/www.maxquest.com/app/dashboard/KYC">-->
        <!--          <font color="#467886">-->
        <!--            <font face="Barlow, serif"><u>www.maxquest.com/app/dashboard/KYC</u></font>-->
        <!--          </font>-->
        <!--        </a>-->
        <font color="#434343">
          <font face="Barlow, serif">to verify their account and follow the guidelines.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>9.2.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We may request identity and address verification when redemptions reach a threshold of US Dollars ($2,000),
            whether in a single transaction or consecutive requests within a rolling period. Verification procedures may
            also be carried out for lower purchases or redemptions, as determined by our analysis of customer behavior.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif">
            <b>
              <br />
              <br />
              9.2.2
            </b>
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You agree that MQ Technology DWC-LLC may use third-party service providers to conduct external
            identification and verification checks on all customers based on the information you provide.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">10. RESPONSIBLE GAMING</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>10.1</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">MQ Technology DWC-LLC actively supports</font></font>
        <font color="#434343">
          <font face="Barlow, serif"><u>Responsible Gaming</u></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            and encourages its Players to make use of various responsible gaming features to manage their Player
            accounts effectively.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>10.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC does not accept any responsibility or liability if you continue gameplay without
            utilizing available exclusionary measures.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">11. FRAUDULENT CONDUCT</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">You are prohibited from:</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1 .1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Hacking into any part of the Games or Platform through password mining, phishing, or any other means.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Attempting to modify, reverse engineer, or reverse-assemble any part of the Games or Platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Introducing viruses, Trojans, worms, logic bombs, spyware, malware, or similar material.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Circumventing the structure, presentation, or navigational function of any Game to obtain information not
            publicly available on the Platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.5</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">Engaging in cheating or collusion.</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.6</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Using the Platform and MQ Technology DWC-LLC's systems for illegal money transfers, including money
            laundering.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.7</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Participating in schemes, organizations, agreements, or groups designed to share special offers or packages
            emailed to specific players and redeemable by URL.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.8</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not use the Platform for unlawful or fraudulent activities or prohibited transactions under
            applicable laws.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>11.1.9</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If MQ Technology DWC-LLC suspects fraudulent, unlawful, or improper activity, your access to the Platform
            will be deactivated immediately, and your Player Account may be suspended. We are not obligated to reverse
            deposits in such cases. MQ Technology DWC-LLC may also report necessary information to relevant authorities,
            other online service providers, electronic payment providers, or financial institutions.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">12. INTELLECTUAL PROPERTY</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>12.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The computer software, graphics, Platform, and user interface provided by MQ Technology DWC-LLC are owned by
            or licensed and protected by copyright laws. You may use the software for personal or recreational use
            following our established rules, terms, and conditions, as well as applicable laws. Streaming is permitted
            and encouraged.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>12.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You acknowledge that MQ Technology DWC-LLC is the owner or authorized licensee of all intellectual property
            related to any Content.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>12.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Your use of the Games and Platform does not grant you any intellectual property rights in the Content,
            Games, or Platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>12.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You grant MQ Technology DWC-LLC an irrevocable, perpetual, worldwide, non-exclusive, royalty-free license to
            use any information, images, videos, comments, messages, music, or profiles you publish or upload to
            websites or social media pages controlled by MQ Technology DWC-LLC.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>12.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not reproduce or modify the Content, including removing any copyright or trademark notice.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>12.6</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            All trademarks and logos displayed in the Games and Platform are the property of MQ Technology DWC-LLC and
            are protected by applicable trademark and copyright laws.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">13. DISRUPTIONS AND CHANGE</font></font>
      </p>
      <h3 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.i68h50kqurls"></a>
        <font color="#434343"><font face="Barlow, serif">13.1 No warranties</font></font>
      </h3>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.1.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The Platform is provided "as is," and to the fullest extent permitted by law, we make no warranty or
            representation regarding its quality, fitness for purpose, completeness, or accuracy.
          </font>
        </font>
      </p>
      <h3 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.nwjfdm4iugxz"></a>
        <font color="#434343"><font face="Barlow, serif">13.2 Malfunctions</font></font>
      </h3>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.2.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC is not liable for any downtime, server disruptions, lag, technical or political
            disturbances to Gameplay, or any misuse of the Platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.2.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC accepts no liability for damages or Net Negative Game Play related to the Platform or
            its Content, including delays, interruptions, data loss, misuse, or errors in Content.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.2.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If a Platform system malfunction occurs, all Game play on that Platform is void.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.2.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            In case a Game fails to conclude due to a system failure, MQ Technology DWC-LLC will make reasonable efforts
            to reinstate funds played by crediting them to your Player Account.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.2.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC reserves the right to remove any part of the Games from the Platform at any time if it
            indicates incorrect behavior affecting redemption, game data, balances, or other balances due to
            misconfiguration or bugs. MQ Technology DWC-LLC may adjust player balances and account details in such cases
            to correct any mistakes.
          </font>
        </font>
      </p>
      <h3 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.kqstwfw2cc4f"></a>
        <font color="#434343"><font face="Barlow, serif">13.3 Service Suspension</font></font>
      </h3>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>13.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We may temporarily suspend all or part of the Platform at our sole discretion. We may provide notice when
            reasonably practicable and will restore the Platform as soon as reasonably practicable after such
            suspension.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">14. VIRUSES</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>14.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            While we take reasonable precautions to protect the Platform and our associated social media channels from
            viruses or phishing attempts, we cannot guarantee they will be entirely free from such risks. It is your
            responsibility to secure your systems and ensure you have the means to recover any lost data or programs
            resulting from a virus.
          </font>
        </font>
      </p>
      <h1 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.e37f4sigrdw9"></a>
        <font color="#000000"><font face="Barlow, serif">15. PRIVACY POLICY</font></font>
      </h1>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>15.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC is dedicated to safeguarding your privacy and complying with all relevant data
            protection and privacy laws.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>15.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Our Privacy Policy is integral to these Terms and Conditions, and accepting it is a prerequisite for account
            registration.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>15.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We respect your privacy. If you consent to receive marketing communications regarding our offerings via
            Email, SMS, or telephone notifications, you may unsubscribe at any time.
          </font>
        </font>
      </p>
      <h1 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.estdgslcru67"></a>
        <font color="#000000"><font face="Barlow, serif">16. LIVE CHAT</font></font>
      </h1>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Our Live Chat service allows you to communicate with our Customer Support representatives. Its use is
            intended for legal purposes only.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">We review and moderate chats and maintain a log and record of statements.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You are prohibited from spamming, intimidating, harassing, or abusing other Players or MQ Technology DWC-LLC
            employees and representatives.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not engage in any form of harassment or offensive behavior on any Live Chat or Social Chat service.
            This includes but is not limited to making threats, derogatory, abusive, or defamatory statements, or using
            racist, sexually explicit, pornographic, obscene, or offensive language.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The Customer Support agent will issue three prompts or warnings before terminating any idle or inappropriate
            Live Chat session.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.6</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not use any Live Chat service to infringe upon the privacy rights, property rights, or any other
            rights of any person.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.7</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not submit any fraudulent or unlawful material or information on any Live Chat or Social Chat
            service.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.8</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not use any Live Chat or Social Chat service to distribute, promote, or publish material containing
            solicitation for funds, advertising, or solicitation for goods or services from other forums.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.9</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You must not use any Live Chat or Social Chat service to distribute, promote, or publish any malicious code
            or engage in any activities that might harm the Platform or other Players' systems.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.10</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We reserve the right to monitor any content submitted by you to any Live Chat service to ensure compliance
            with our content guidelines, which are monitored and subject to change from time to time.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.11</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Breaching any provisions related to Live Chat or Social Chat services may result in a ban from using that
            service and/or suspending or deactivating your Player Account. If we deactivate your Player Account, we
            reserve the right to cancel or refuse to redeem any Prizes.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>16.12</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We reserve the right to remove any Live Chat or Social Chat service operated by MQ Technology DWC-LLC if it
            is abused.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif">
          <font size="5" style="font-size: 20pt">17. COMPLAINTS AND CUSTOMER SUPPORT</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>17.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If you have complaints or queries, you can contact our Customer Support team at any time through the contact
            page.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>17.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">To expedite the process, we recommend providing the following information:</font>
        </font>
      </p>
      <ul>
        <li>
          <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0in">
            <font color="#434343">
              <font face="Barlow, serif">Your username and email as registered on your Player Account.</font>
            </font>
          </p>
        </li>
        <li>
          <p style="line-height: 100%; margin-bottom: 0in">
            <font color="#434343">
              <font face="Barlow, serif">A detailed explanation of the complaint/query.</font>
            </font>
          </p>
        </li>
        <li>
          <p style="line-height: 100%; margin-bottom: 0.25in">
            <font color="#434343">
              <font face="Barlow, serif">
                Any specific dates and times associated with the complaint/query (if applicable).
              </font>
            </font>
          </p>
        </li>
      </ul>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>17.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Failure to submit a written communication with the information outlined above may result in a delay in our
            ability to identify and respond to your complaint/query promptly.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif">
          <font size="5" style="font-size: 20pt">18. DEACTIVATION/SUSPENSION OF YOUR ACCOUNT</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We reserve the right, at our sole discretion, to deactivate or suspend your Player Account if we have reason
            to believe that you have engaged or are likely to engage in any of the following activities:
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You breached or assisted another party in breaching any provision of these Terms and Conditions, promotional
            terms, or any other terms in place.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.2</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">You have more than one Player Account.</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Your communication with us consists of harassment or offensive behavior, including (but not limited to)
            making threatening, derogatory, abusive, or defamatory statements or using racist, sexually explicit,
            pornographic, obscene, or offensive language.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">Your Player Account is deemed to be an Inactive Account.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.5</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">You provide incorrect or misleading information.</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.6</b></font>
        </font>
        <font color="#434343"><font face="Barlow, serif">Your identity (if requested) cannot be verified.</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.7</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You attempt to use your Player Account through a VPN, proxy, or similar service that masks or manipulates
            the identification of your real location or by otherwise providing false or misleading information regarding
            your citizenship, location, or place of residence or by playing Games using the Platform through a third
            party or on behalf of a third party. We will permit VPN use for verified members in legal jurisdictions on a
            case-by-case basis, depending on our ability to verify the user’s legal use of our platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.8</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You are not over 18 years of age or such higher minimum legal age of majority as stipulated in the
            jurisdiction of your residence.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.9</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You are located in one of the Excluded Territories listed in these Terms &amp; Conditions Definitions
            (Section.1).
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.10</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You have allowed or permitted (whether intentionally or unintentionally) someone else to Participate using
            your Player Account.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.11</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You have failed our due diligence procedures or are found to be colluding, cheating, money laundering, or
            undertaking any kind of fraudulent activity.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.1.12</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You have employed or made use of a system (including machines, computers, software, or other automated
            systems such as bots) which give you an unfair advantage.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If MQ Technology DWC-LLC deactivates or suspends your Player Account for any of the reasons referred to
            above, you will be liable for any and all claims, losses, liabilities, damages, costs, and expenses incurred
            or suffered by MQ Technology DWC-LLC. You will indemnify and hold MQ Technology DWC-LLC harmless on demand
            for such claims. We also reserve the right to withhold all or part of the balance and/or recover any Prizes
            from your Player Account.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>18.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If your Player Account is deactivated due to the closure of the Platform or a similar event, we will make
            commercially reasonable efforts to enable the redemption of any existing Prizes associated with your Player
            Account.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif">
          <font size="5" style="font-size: 20pt">19. INDEMNITY AND LIMITATION OF LIABILITY</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>19.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You agree to release and to indemnify, defend and hold harmless MQ Technology DWC-LLC and its parents,
            subsidiaries, affiliates, and agencies, as well as the officers, directors, employees, shareholders and
            representatives of any of the foregoing entities, from and against any and all losses, liabilities,
            expenses, damages, costs (including attorneys’ fees and court costs) claims or actions of any kind
            whatsoever arising or resulting from your use of the Platform, your violation of these Terms and Conditions,
            your receipt, ownership, use or misuse of any prize, and any of your acts or omissions that implicate
            publicity rights, defamation or invasion of privacy. MQ Technology DWC-LLC reserves the right, at its own
            expense, to assume exclusive defense and control of any matter otherwise subject to indemnification by you
            and, in such case, you agree to cooperate with MQ Technology DWC-LLC in the defense of such
          </font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            matter.
            <br />
          </font>
        </font>
        <br />
        <br />
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif">
            <font size="4" style="font-size: 16pt">
              <b>20. CLASS ACTION WAIVER; DISPUTE RESOLUTION; GOVERNING LAW; AND MANDATORY ARBITRATION</b>
            </font>
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            PLEASE READ THIS SECTION CAREFULLY BECAUSE IT AFFECTS YOUR RIGHTS. BY AGREEING TO MANDATORY, BINDING
            ARBITRATION, YOU WAIVE YOUR RIGHT TO LITIGATE DISPUTES THROUGH A COURT AND TO HAVE A JUDGE OR JURY DECIDE
            YOUR CASE. THIS SECTION ALSO INCLUDES A CLASS ACTION WAIVER.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            These Terms and Conditions are governed by and construed in accordance with, the laws of the United States
            and the State of Delaware without regard to the conflicts of law principles thereof. Suppose any clause or
            provision of these Terms and Conditions is found to be invalid by any court having competent jurisdiction.
            In that case, the invalidity of such clause or provision shall not affect the validity of the remaining
            clauses or provisions of these Terms and Conditions, including but not limited to the class action waiver.
            You expressly agree that if you dispute the validity or enforceability of the individual arbitration
            provision and/or class action waiver in these Terms, you shall bring such dispute in the courts of the State
            of Delaware, and you expressly consent and agree to submit to the exclusive personal jurisdiction and venue
            of such courts.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            All claims arising in connection with your use of the Platform should be reported and brought to our
            attention as soon as possible to Customer Support by Section 17 above. MQ Technology DWC-LLC agrees that we
            will make all reasonable efforts to contact you and resolve any claim it may possess informally prior to
            taking any formal action. Most concerns are quickly resolved in this manner to our customers’; satisfaction.
            The parties shall use their best efforts to settle any dispute, claim, question, or disagreement directly
            through consultation and good faith negotiations, which shall be a precondition for either party initiating
            a lawsuit or arbitration. To the maximum extent permitted by law, you permanently and irrevocably waive your
            rights to bring any claim in connection with your use of the Platform unless you bring it within two (2)
            years of the date of the event giving rise to such claim.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            EXCEPT FOR DISPUTES THAT QUALIFY TO BE HEARD IN SMALL CLAIMS COURT, TO THE FULLEST EXTENT PERMITTED BY LAW,
            ALL DISPUTES ARISING OUT OF OR RELATED TO THESE TERMS OR ANY ASPECT OF THE RELATIONSHIP BETWEEN YOU, ON THE
            ONE HAND, AND MQ TECHNOLOGY DWC-LLC OR ANY OF ITS AFFILIATES, LICENSORS, OR SUPPLIERS, ON THE OTHER HAND,
            WHETHER BASED IN CONTRACT, TORT, STATUTE, FRAUD, MISREPRESENTATION, OR ANY OTHER THEORY, WILL BE RESOLVED
            THROUGH FINAL AND BINDING ARBITRATION BEFORE A NEUTRAL ARBITRATOR INSTEAD OF IN A COURT BY A JUDGE OR JURY.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.5</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            YOU AGREE THAT MQ TECHNOLOGY DWC-LLC AND YOU ARE EACH WAIVING THE RIGHT TO TRIAL BY A JURY. YOU FURTHER
            AGREE THAT ANY ARBITRATION WILL TAKE PLACE ON AN INDIVIDUAL BASIS ONLY AND THAT CLASS ARBITRATIONS, CLASS
            ACTIONS, AND OTHER REPRESENTATIVE ACTIONS ARE NOT PERMITTED. YOU HEREBY AGREE TO GIVE UP THE ABILITY TO
            BRING OR PARTICIPATE IN A CLASS ACTION OR OTHER REPRESENTATIVE ACTION IN COURT OR ARBITRATION.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.6</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The arbitration will be administered by JAMS in accordance with the provisions of its Comprehensive
            Arbitration Rules or Streamlined Arbitrations Rules, as appropriate, excluding any rules or procedures
            governing or permitting class actions. The JAMS Rules governing the arbitration may be accessed at
            http://www.jamsadr.com/ or by calling JAMS at (800) 352-5267. The arbitrator will conduct hearings, if any,
            by teleconference or videoconference rather than by personal appearances unless the arbitrator determines
            upon request by you or by us that an in-person hearing is appropriate. Any in-person appearances will be
            held at a reasonably convenient location for the parties with due consideration of their ability to travel
            and other pertinent circumstances. If the parties are unable to agree on a location, such determination will
            be made by the JAMS or by the arbitrator. If you are able to demonstrate that the costs of arbitration will
            be prohibitive as compared to the costs of litigation, we will, to the extent required to make this Section
            13 enforceable, pay as much of your filing and hearing fees in connection with the arbitration as the
            arbitrator deems necessary to prevent the arbitration from being cost-prohibitive. The arbitrator will be
            bound by these Terms when not in conflict with applicable law, and the arbitrator’s decision will be binding
            and final, subject only to the limited right of judicial review provided under the Federal Arbitration Act.
            The arbitrator will have the authority to award temporary, interim, or permanent injunctive relief or relief
            providing for specific performance of these Terms, but only to the extent necessary to provide relief
            warranted by the individual claim before the arbitrator. Suppose the arbitrator decides that either the
            substance of your claim or the remedy you asked for is frivolous or brought for an improper purpose. In that
            case, we may use the applicable Rules to determine whether you are responsible for the filing,
            administrative, and arbitrator fees. The award rendered by the arbitrator may be confirmed and enforced in
            any court having jurisdiction thereof. Notwithstanding any of the foregoing, nothing in these Terms will
            preclude you from bringing issues to the attention of federal, state, or local government agencies or from
            seeking public injunctive relief in court where that right cannot be waived under applicable state law.
          </font>
        </font>
      </p>
      <p style="line-height: 115%; margin-top: 0.21in; margin-bottom: 0in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.7</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If you are a resident of the United States, arbitration will take place in Delaware. For residents outside
            the United States, arbitration shall be initiated in Delaware, and you and we agree to submit to the
            personal jurisdiction of any federal or state court in Delaware, in order to compel arbitration, to stay
            proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered by
            the arbitrator.
          </font>
        </font>
      </p>
      <p style="line-height: 115%; margin-top: 0.21in; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0.26in">
        <font color="#434343">
          <font face="Barlow, serif"><b>20.8</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            To not be bound by the arbitration agreement set forth in this Section 20, within 30 days of using our
            Platform, you must notify MQ Technology DWC-LLC in writing of your intent to opt-out of the arbitration
            provisions. The written intent to opt-out must include your first and last name and be provided either by:
            contacting our customer support; or (2) sending a letter to the following address: Dubai South Business
            Center, Building C, 3rd Floor, Dubai Logistic City, PO BOX 390667, Dubai, U.A.E.
            <br />
            <br />
          </font>
        </font>
        <font face="Barlow, serif"><font size="5" style="font-size: 20pt">21. NETWORK CONNECTION</font></font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.1 Definition:</b></font>
        <font face="Barlow, serif">
          High latency significantly delays transmitting data packets over a network. Latency is the time it takes for
          data to travel from source to destination. When latency is high, there's a noticeable delay between when data
          is sent and when it's received, leading to slower communication and potentially impacting the performance of
          real-time applications like online gaming.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.2 Responsibility:</b></font>
        <font face="Barlow, serif">
          Users are responsible for monitoring their internet connection and addressing any latency issues during online
          gaming sessions. This includes ensuring a stable and reliable internet connection, minimizing network
          congestion, and optimizing hardware and software settings for gaming.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.3 Action:</b></font>
        <font face="Barlow, serif">
          In the event of high latency, users are advised to take necessary actions to improve their gaming experience.
          This may include troubleshooting their internet connection or adjusting their device’s settings.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.4 Disclaimer:</b></font>
        <font face="Barlow, serif">
          MaxQuest conducts extensive testing on all games at various latency levels, ensuring optimal performance and
          fairness. MaxQuest does not guarantee the elimination of latency issues or uninterrupted gameplay. Users
          acknowledge that external factors such as network congestion, server performance, and hardware limitations may
          affect gaming experiences. However, MaxQuest is committed to maintaining optimal server performance to
          minimize latency and enhance user experience.
        </font>
      </p>
      <p style="line-height: 115%; margin-left: 0.5in; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.5 Refund Policy:</b></font>
        <font face="Barlow, serif">
          MaxQuest reserves the right to decline any refund requests in cases where high latency is visible during
          online gaming sessions. Users understand and acknowledge that latency issues may arise due to various factors
          beyond MaxQuest's control. Therefore, users are encouraged to take proactive measures to address latency
          issues as outlined in the responsibility and action sections above. Users agree to abide by this refund policy
          when participating in online gaming sessions at MaxQuest.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.6 Acknowledgment:</b></font>
        <font face="Barlow, serif">
          By participating in online gaming sessions at MaxQuest, users acknowledge that they have read, understood, and
          agreed to these terms and conditions, including the refund policy regarding high latency issues. Users further
          understand and accept that while MaxQuest endeavors to provide a seamless gaming experience, factors such as
          network conditions, server performance, and hardware limitations may affect gameplay. Therefore, users agree
          that they will not hold MaxQuest liable for any disruptions or inconveniences caused by high latency or other
          related issues during online gaming sessions.
        </font>
      </p>
      <p style="line-height: 115%; margin-left: 0.5in; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif">
          To help mitigate the effects of high latency and ensure smoother communication experiences, we recommend users
          follow the guidelines below:
        </font>
      </p>
      <p style="line-height: 115%; margin-left: 0.5in; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.7 Use a Wired Connection:</b></font>
        <font face="Barlow, serif">
          Connect your device directly to the network using an Ethernet cable rather than relying on Wi-Fi. Wired
          connections generally offer lower latency and more stable connections.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.8 Close Background Applications:</b></font>
        <font face="Barlow, serif">
          Close any unnecessary applications running in the background, especially those consuming significant
          bandwidth, as they can contribute to network congestion and increase latency.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.9 Check for Network Interference:</b></font>
        <font face="Barlow, serif">
          Minimize potential sources of interference such as other electronic devices, physical obstacles, or competing
          Wi-Fi networks. Position your device closer to the router for better signal strength.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.10 Choose Off-Peak Hours:</b></font>
        <font face="Barlow, serif">
          Consider using bandwidth-intensive applications when network traffic is lower during off-peak hours, reducing
          the likelihood of congestion and latency spikes.
        </font>
      </p>
      <p style="line-height: 115%; margin-left: 0.5in; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.11 Update Firmware and Drivers:</b></font>
        <font face="Barlow, serif">
          Ensure your network equipment, including routers and network interface cards, runs the latest firmware and
          drivers to optimize performance and compatibility.
        </font>
      </p>
      <p style="line-height: 115%; margin-left: 0.5in; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>21.12</b></font>
        <font face="Barlow, serif">
          Adherence to these guidelines can significantly enhance network efficiency and mitigate the impact of high
          latency on user experiences.
        </font>
      </p>
      <h1 class="western" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <a name="_heading=h.ns3mfk7tsqc9"></a>
        <font color="#000000"><font face="Barlow, serif">22. UNFAIR ADVANTAGE</font></font>
      </h1>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font face="Barlow, serif"><b>22.1</b></font>
        <font face="Barlow, serif">
          MaxQuest is dedicated to ensuring a fair and competitive environment for all players on our platform. We
          strictly prohibit any actions or behaviors that provide an unfair advantage. This policy is designed to
          protect our players and maintain the integrity of our games.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2 Prohibited Practices:</b></font>
        <font face="Barlow, serif">
          Unfair practices include, but are not limited to, the following activities:
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.1 Deposit-Dumping:</b></font>
        <font face="Barlow, serif">
          Deposit-dumping involves a player intentionally losing games to transfer their funds to another player. Any
          player found engaging in or attempting deposit-dumping will face disciplinary actions, ranging from warnings
          and temporary suspensions to permanent account closure and forfeiture of funds.
        </font>
        <font face="Barlow, serif"><br /></font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.2 Multiple Accounts (Multi-Accounting):</b></font>
        <font face="Barlow, serif">
          Players are prohibited from creating multiple accounts for the purpose of gaining an unfair advantage. Each
          player may only have one account on MaxQuest. Violation of this policy will result in disciplinary measures,
          including warnings, temporary suspensions, or permanent account closure and forfeiture of funds.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.3 Collusion:</b></font>
        <font face="Barlow, serif">
          Collusion occurs when two or more players work together to gain an advantage over others. This includes
          sharing information, manipulating game outcomes, or any other form of cooperation that disrupts fair play.
          Players caught colluding will face severe penalties, including warnings, temporary suspensions, or permanent
          account closure and forfeiture of funds.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.4 Account Sharing/Third-Party Usage:</b></font>
        <font face="Barlow, serif">
          Players are responsible for protecting their account credentials. Sharing accounts or allowing third parties
          to access your account is strictly prohibited. Any player found sharing their account will face consequences,
          from warnings and temporary suspensions to permanent account closure and forfeiture of funds.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <!--        <font face="Barlow, serif"><b>22.2.4.1</b></font>-->
        <!--        <font face="Barlow, serif">-->
        <!--          We reserve the right to suspend all redemptions until KYC (Know Your Customer) verification is completed and-->
        <!--          account ownership is established for all suspected shared or third-party accounts. We will investigate all-->
        <!--          instances of suspected shared or third-party usage and take necessary actions once account ownership is-->
        <!--          confirmed.-->
        <!--          <br />-->
        <!--        </font>-->
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.5 Extracting Player Profiles:</b></font>
        <font face="Barlow, serif">
          The use of programs or methods to gather and exploit player data is forbidden. This includes screen-scraping,
          reading chat histories, or accessing player data to gain an advantage. Violations will result in permanent
          account closure and forfeiture of funds.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.6 Use of Artificial Intelligence (AI):</b></font>
        <font face="Barlow, serif">
          The use of AI to interact with the MaxQuest platform is prohibited. All actions must be performed by the
          player without assistance from automated systems. Players using AI tools will face permanent account closure
          and forfeiture of funds.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.7 Use of Bots:</b></font>
        <font face="Barlow, serif">
          Bots, or automated programs designed to play in place of a human, are not allowed on MaxQuest. The use of Bots
          to gain an advantage will lead to permanent account closure and forfeiture of funds.
          <br />
        </font>
        <br />
      </p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.2.8 Real-Time Assistance (RTA) Tools:</b></font>
        <font face="Barlow, serif">
          The use of RTA tools, which provide real-time suggestions to players, is strictly prohibited. Players using
          such tools will face permanent account closure and forfeiture of funds.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.3</b></font>
        <font face="Barlow, serif">MaxQuest reserves the right to require video evidence of unassisted gameplay.</font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.4</b></font>
        <font face="Barlow, serif">
          MaxQuest reserves the right to take necessary actions to enforce these policies and ensure a fair gaming
          environment for all players. By playing on MaxQuest, you agree to abide by these rules and uphold the
          integrity of the community.
        </font>
      </p>
      <p style="line-height: 115%; margin-bottom: 0in"><br /></p>
      <p style="line-height: 115%; margin-bottom: 0in">
        <font face="Barlow, serif"><b>22.5</b></font>
        <font face="Barlow, serif">
          Violations of these policies may result in the penalties outlined above or any other actions deemed
          appropriate by MaxQuest.
        </font>
        <font face="Barlow, serif">
          <font size="2" style="font-size: 11pt"><br /></font>
        </font>
        <font color="#000000"><font face="Barlow, serif">23. ENTIRE AGREEMENT</font></font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            These Terms and Conditions constitute the entire agreement between you and MQ Technology DWC-LLC with
            respect to your Participation. With the exception of cases of fraud, these Terms supersede all prior or
            contemporaneous communications and proposals, whether electronic, oral, or written, between you and MQ
            Technology DWC-LLC with respect to your Participation.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.2 Amendments</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.2.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC reserves the right to amend these Terms and Conditions or to implement or amend any
            procedures at any time. Any amendments will be published on the Platform, and such changes will be binding
            and effective immediately.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.2.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Whenever we amend these Terms and Conditions in a way that would limit your current rights or maybe to your
            detriment, we will notify you upon your next visit to the Platform, and you will be required to re-confirm
            your acceptance before playing. If you do not agree to the amended Terms and Conditions, you must stop using
            the Platform.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.4 Tax</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            You are solely responsible for any taxes that apply to any Prizes you collect from your Participation.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.5 Force Majeure</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC will not be liable or responsible for any failure to perform or delay in the
            performance of any of our obligations under these Terms and Conditions that are caused by events outside of
            our reasonable control.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.6 No Agency</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            Nothing in these Terms and Conditions will be construed as creating any agency, partnership, trust
            arrangement, fiduciary relationship, or any other form of joint enterprise between you and MQ Technology
            DWC-LLC.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.7 Severability</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            If any of the Terms and Conditions are determined by any competent authority to be invalid, unlawful, or
            unenforceable to any extent, such term, condition, or provision will, to that extent, be severed from these
            Terms and Conditions. All remaining terms, conditions, and provisions will continue to be valid to the
            fullest extent permitted by law. In such cases, the part deemed invalid or unenforceable will be amended in
            a manner consistent with the applicable law to reflect, as closely as possible, MQ Technology DWC-LLC’s
            original intent.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8 Explanation of Terms and Conditions</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            We consider these Terms and Conditions to be open and fair. If you need any explanation regarding these
            Terms and Conditions or any other part of our Platform, contact Customer Support.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8.2</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            The Terms and Conditions prevail over any communication undertaken via Email, Live Chat, or any other
            medium.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8.3</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">All correspondence between you and MQ Technology DWC-LLC may be recorded.</font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8.4</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            These Terms and Conditions are personal to you and are not assignable, transferable, or sub-licensable by
            you except with our prior written consent. We reserve the right to assign, transfer, or delegate any of our
            rights and obligations hereunder to any third party without notice to you.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8 Business Transfers</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.8.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            In the event of a change of control, merger, acquisition, or sale of assets of MQ Technology DWC-LLC, your
            Player Account, and associated data may be part of the assets transferred to the purchaser or acquiring
            party. In such an event, we will provide you with notice via email or via our Platform explaining your
            options with regard to the transfer of your Player Account.
          </font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.9 Language</b></font>
        </font>
      </p>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>23.9.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            These Terms and Conditions may be published in several languages for information purposes and ease of access
            by players but will all reflect the same principles. It is only the English version that is the legal basis
            of the relationship between you and us, and in case of any discrepancy between a non-English version and the
            English version of these Terms and Conditions, the English version will prevail.
          </font>
        </font>
      </p>
      <h1 class="western" style="line-height: 115%; margin-top: 0.17in; margin-bottom: 0.17in">
        <a name="_heading=h.f73v25c6qvop"></a>
        <font color="#000000"><font face="Barlow, serif">24 OTHER</font></font>
      </h1>
      <p style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.25in">
        <font color="#434343">
          <font face="Barlow, serif"><b>24.1</b></font>
        </font>
        <font color="#434343">
          <font face="Barlow, serif">
            MQ Technology DWC-LLC, Registration No. 10641, registered at Dubai South Business Center, Building C, 3rd
            Floor, Dubai Logistic City, PO BOX 390667, Dubai, U.A.E.
          </font>
        </font>
      </p>
    </div>
  </div>
</template>

<style scoped>
  .tnc-wrapper {
    padding-top: 20px;
  }

  @media (max-width: 1024px) {
    .hide--mobile {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    .hide--desktop {
      display: none;
    }
  }

  @page {
    size: 8.5in 11in;
    margin: 1in;
  }

  * {
    color: white !important;
  }

  b {
    font-weight: bold;
  }

  p {
    line-height: 115%;
    text-align: left;
    orphans: 2;
    widows: 2;
    margin-bottom: 0.1in;
    direction: ltr;
    background: transparent;
  }

  h1 {
    font-size: 20pt;
    line-height: 100%;
    text-align: left;
    page-break-inside: avoid;
    orphans: 2;
    widows: 2;
    margin-top: 0.28in;
    margin-bottom: 0.08in;
    direction: ltr;
    background: transparent;
    page-break-before: auto;
    page-break-after: avoid;
  }

  h3 {
    color: #434343;
    line-height: 100%;
    text-align: left;
    page-break-inside: avoid;
    orphans: 2;
    widows: 2;
    margin-top: 0.22in;
    margin-bottom: 0.06in;
    direction: ltr;
    background: transparent;
    page-break-before: auto;
    page-break-after: avoid;
  }

  h3.western {
    font-size: 14pt;
    font-weight: normal;
  }

  h3.cjk {
    font-size: 14pt;
    font-weight: normal;
  }

  h3.ctl {
    font-size: 14pt;
  }

  h6 {
    color: #666666;
    line-height: 100%;
    text-align: left;
    page-break-inside: avoid;
    orphans: 2;
    widows: 2;
    margin-bottom: 0.06in;
    direction: ltr;
    background: transparent;
    page-break-before: auto;
    page-break-after: avoid;
  }

  h6.western {
    font-size: 11pt;
    font-style: italic;
  }

  h6.cjk {
    font-size: 11pt;
    font-style: italic;
  }

  h6.ctl {
    font-size: 11pt;
  }

  a:link {
    color: #000080;
    text-decoration: underline;
  }

  .dark {
    color: #1e1e1e !important;

    * {
      color: #1e1e1e !important;
    }
  }
</style>
